// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"Y0-z"};